import React from 'react';
import { Modal, Button } from 'react-bootstrap'
import * as Notifications from 'fw/globals/Notifications'

class CustomDialog extends React.Component {
	constructor(props) {
		super(props);
		this.state = { visible: props.visible };
	}

	componentWillReceiveProps(props, nextProps)
	{
		this.setState({ visible: props.visible });
	}

	customButton = () => {
		Notifications.success("Your custom button was clicked.");
	}

	close = () => {
		this.setState({ visible: false }, function () {
			Notifications.error("Bye bye from your custom dialog.");
			this.props.onClose();
		});
	}

	render() {
		return (
			<Modal show={this.state.visible} onHide={this.close}>
				<Modal.Header>
					<Modal.Title>My custom dialog header</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<h4>My custom dialog body!</h4>
				</Modal.Body>
				<Modal.Footer>
					<Button bsStyle="success" onClick={this.customButton}>Custom Button</Button>
					<Button onClick={this.close}>Close</Button>
				</Modal.Footer>
			</Modal>
		)
	}
}

export default CustomDialog;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/Modals/CustomDialog.js